import { render } from "./IVkAds.vue?vue&type=template&id=4c51900c"
import script from "./IVkAds.vue?vue&type=script&lang=js"
export * from "./IVkAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__